import { getRangeText } from "@xbs/lib-dom";
import { isDefined } from "../helpers";
import { checkSelectedTasks } from "../actions/task/check";
import { uncheckSelectedTasks } from "../actions/task/uncheck";
import { addTask } from "../actions/task/add";
import { deleteSelectedTasks } from "../actions/task/delete";
import { duplicateSelectedTasks } from "../actions/task/duplicate";
import { copySelectedTasks } from "../actions/task/copy";
import { pasteCopiedTasks } from "../actions/task/paste";
import { indentSelectedTasks } from "../actions/task/indent";
import { unindentSelectedTasks } from "../actions/task/unindent";
import { setPrioritySelectedTasks } from "../actions/task/priority";
import { moveSelectedTasksDown, moveSelectedTasksUp, } from "../actions/task/move";
export default function (store, { code, event }) {
    const { selected, stateEditableItem, filter, stateSearch, menuState, stateDueDate, stateCombo, } = store.getState();
    const isEditorOpen = isDefined(stateEditableItem?.id);
    const lastSelected = selected.at(-1);
    if (isDefined(lastSelected) && !stateSearch?.focus && !stateCombo?.open) {
        taskKeyHandlers(store, code, event);
    }
    if (stateEditableItem?.type === "project") {
        projectHandlers(store, code, event);
    }
    switch (code) {
        case "escape":
            if (menuState) {
                store.in.exec("close-menu", {
                    ...menuState,
                });
            }
            else if (isEditorOpen) {
                store.in.exec("close-inline-editor", {
                    ...stateEditableItem,
                    save: false,
                });
            }
            else if (stateDueDate?.open || stateCombo?.open) {
                store.in.exec("set-state-due-date", {
                    ...stateDueDate,
                    open: false,
                });
                store.in.exec("set-state-combo", {
                    open: false,
                });
            }
            else {
                filter && store.in.exec("set-filter", { match: null });
                stateSearch?.open &&
                    store.in.exec("set-state-search", {
                        ...stateSearch,
                        value: null,
                        open: false,
                        dropdown: { open: false },
                    });
            }
            break;
        // FIXME: something's wrong with focus after some operations like "delete-task"
        case "ctrl+z":
            event.preventDefault();
            store.undo();
            break;
        case "ctrl+shift+z":
        case "ctrl+y":
            event.preventDefault();
            store.redo();
            break;
    }
}
function projectHandlers(store, code, event) {
    const { stateEditableItem, readonly } = store.getState();
    const isEditorOpen = isDefined(stateEditableItem?.id);
    if (!readonly) {
        switch (code) {
            case "enter":
                event.preventDefault();
                if (isEditorOpen) {
                    store.in.exec("close-inline-editor", {
                        id: stateEditableItem.id,
                    });
                }
                break;
        }
    }
}
function taskKeyHandlers(store, code, event) {
    const { selected, stateEditableItem, readonly, filter } = store.getState();
    const isEditorOpen = isDefined(stateEditableItem?.id);
    const lastSelected = selected.at(-1);
    const task = store.getTask(lastSelected);
    if (stateEditableItem?.dropdown)
        return;
    if (!readonly) {
        switch (code) {
            case "shift+arrowup":
                selectNearTask(store, "prev");
                break;
            case "shift+arrowdown":
                selectNearTask(store, "next");
                break;
            case "shift+tab":
                event.preventDefault();
                unindentSelectedTasks({ store });
                break;
            case "tab":
                event.preventDefault();
                indentSelectedTasks({ store });
                break;
            case "delete":
            case "backspace":
                if (!isEditorOpen)
                    deleteSelectedTasks({ store });
                break;
            case "enter":
                event.preventDefault();
                if (isEditorOpen) {
                    if (!stateEditableItem?.currentValue &&
                        isDefined(task.parent)) {
                        store.in.exec("unindent-task", {
                            id: stateEditableItem.id,
                        });
                        store.in.exec("open-inline-editor", {
                            id: stateEditableItem.id,
                            type: "task",
                        });
                    }
                    else {
                        store.in.exec("close-inline-editor", {
                            id: stateEditableItem.id,
                        });
                    }
                }
                else if (!isDefined(filter?.match)) {
                    addTask({ store, task });
                }
                break;
            case "ctrl+enter":
                !isEditorOpen &&
                    store.in.exec("open-inline-editor", {
                        id: lastSelected,
                        type: "task",
                    });
                break;
            case "ctrl+d":
                event.preventDefault();
                duplicateSelectedTasks({ store });
                break;
            case "ctrl+c":
                !getRangeText()?.length && copySelectedTasks({ store });
                break;
            case "ctrl+v":
                !isEditorOpen && pasteCopiedTasks({ store, id: lastSelected });
                break;
            case "ctrl+arrowup":
                moveSelectedTasksUp({ store });
                break;
            case "ctrl+arrowdown":
                moveSelectedTasksDown({ store });
                break;
            case "alt+0":
                setPrioritySelectedTasks({ store, priority: null });
                break;
            case "alt+1":
                setPrioritySelectedTasks({ store, priority: 1 });
                break;
            case "alt+2":
                setPrioritySelectedTasks({ store, priority: 2 });
                break;
            case "alt+3":
                setPrioritySelectedTasks({ store, priority: 3 });
                break;
        }
    }
    switch (code) {
        case "arrowup":
            setArrowHandlers(store, "up");
            break;
        case "arrowdown":
            setArrowHandlers(store, "down");
            break;
        case "arrowleft":
            setArrowHandlers(store, "left");
            break;
        case "arrowright":
            setArrowHandlers(store, "right");
            break;
        case "space":
            if (!isEditorOpen) {
                event.preventDefault();
                if (task?.checked) {
                    uncheckSelectedTasks({ store });
                }
                else {
                    checkSelectedTasks({ store });
                }
            }
            break;
    }
}
function setArrowHandlers(store, action) {
    const { selected, treeTasks, stateEditableItem, filter, taskShape } = store.getState();
    const lastSelected = selected.at(-1);
    if (isDefined(stateEditableItem?.id))
        return;
    if (!isDefined(lastSelected)) {
        store.in.exec("select-task", {
            id: treeTasks.at(0)?.id,
        });
        return;
    }
    const hideCompleted = taskShape?.completed?.taskHide;
    const task = store.getTask(lastSelected);
    const filtered = isDefined(filter);
    let nextSelect;
    switch (action) {
        case "up":
            nextSelect = store.getNearId({
                id: lastSelected,
                dir: "prev",
                filtered,
                hideCompleted,
            });
            break;
        case "down":
            nextSelect = store.getNearId({
                id: lastSelected,
                filtered,
                hideCompleted,
            });
            break;
        case "left":
            if (store.hasChildren(task.id, filtered, hideCompleted) &&
                !task.collapsed) {
                store.in.exec("collapse-task", { id: task.id });
            }
            else {
                nextSelect = task?.parent;
            }
            break;
        case "right":
            if (store.hasChildren(task.id, filtered, hideCompleted) &&
                task.collapsed) {
                store.in.exec("expand-task", { id: task.id });
            }
            break;
    }
    isDefined(nextSelect) &&
        store.in.exec("select-task", {
            id: nextSelect,
        });
}
function selectNearTask(store, dir = "next") {
    const { selected, filter, taskShape } = store.getState();
    const hideCompleted = taskShape?.completed?.taskHide;
    const filtered = isDefined(filter);
    const lastSelect = selected.at(-1);
    const nextSelect = store.getNearId({
        id: lastSelect,
        dir,
        filtered,
        hideCompleted,
    });
    if (!isDefined(nextSelect))
        return;
    if (selected.length > 1 && store.getTask(nextSelect)?.selected) {
        store.in.exec("unselect-task", { id: lastSelect });
        return;
    }
    store.in.exec("select-task", {
        id: nextSelect,
        join: true,
    });
    if (dir === "next") {
        const children = store.getChildrenIds({ id: nextSelect });
        for (const childId of children) {
            if (!store.getTask(childId)?.selected) {
                store.in.exec("select-task", {
                    id: childId,
                    join: true,
                });
            }
        }
    }
}
//# sourceMappingURL=keyNavigation.js.map